import { storageManager } from './storage';
import { GlobalSettings } from './types';
import { DEFAULT_GLOBAL_SETTINGS, STORAGE_KEYS } from './constants';

// 获取全局设置
export const getGlobalSettings = async (): Promise<GlobalSettings> => {
  try {
    const settings = await storageManager.getSetting<GlobalSettings>(STORAGE_KEYS.GLOBAL_SETTINGS);
    return {
      ...DEFAULT_GLOBAL_SETTINGS,
      ...settings,
    };
  } catch (error) {
    console.error('Failed to get global settings:', error);
    return DEFAULT_GLOBAL_SETTINGS;
  }
};

// 保存全局设置
export const saveGlobalSettings = async (settings: GlobalSettings): Promise<void> => {
  try {
    await storageManager.setSetting(STORAGE_KEYS.GLOBAL_SETTINGS, settings);
  } catch (error) {
    console.error('Failed to save global settings:', error);
    throw error;
  }
};

// 更新部分全局设置
export const updateGlobalSettings = async (partialSettings: Partial<GlobalSettings>): Promise<void> => {
  try {
    const currentSettings = await getGlobalSettings();
    const newSettings = { ...currentSettings, ...partialSettings };
    await saveGlobalSettings(newSettings);
  } catch (error) {
    console.error('Failed to update global settings:', error);
    throw error;
  }
};

// 获取特定设置
export const getGlobalSetting = async <K extends keyof GlobalSettings>(
  key: K
): Promise<GlobalSettings[K]> => {
  const settings = await getGlobalSettings();
  return settings[key];
};
